function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "IMG_02",
  transform: "translate(-611 -39.443)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_Box",
  transform: "translate(611 39.443)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1,
  opacity: 0
}, /*#__PURE__*/React.createElement("rect", {
  width: 640,
  height: 376,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 639,
  height: 375,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_86",
  "data-name": "Pfad 86",
  d: "M-624,311.533h27.134V179.169l59.749-14.726V319.477l-59.749-7.944",
  transform: "translate(1478 0)",
  fill: "none",
  stroke: "#333330",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_87",
  "data-name": "Pfad 87",
  d: "M-513.346,182.133h40.1V316.079h27.9",
  transform: "translate(1454.229 -3.8)",
  fill: "none",
  stroke: "#333330",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_88",
  "data-name": "Pfad 88",
  d: "M-471.461,352.727h-41.888",
  transform: "translate(1454.23 -40.447)",
  fill: "none",
  stroke: "#333330",
  strokeLinecap: "round",
  strokeWidth: 6
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_21",
  "data-name": "Rechteck 21",
  width: 14,
  height: 6,
  rx: 3,
  transform: "translate(919 241.443)",
  fill: "#333330"
}));

function SvgDoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 376,
    viewBox: "0 0 640 376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.3138ec47dea846d41bd008666a2c11fd.svg";
export { ForwardRef as ReactComponent };